import { Box } from "@mui/material";
import styled, { css } from "styled-components";

type CalendarProps = {
  isSelected?: boolean;
};

export const Container = styled(Box)<CalendarProps>`
  min-width: 55px;
  height: 60px;
  border-radius: 10px;
  cursor: pointer;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  ${(props) =>
    props.isSelected
      ? css`
          color: #FFFFFF;
          background-color: ${(props) => props.theme.palette.primary.dark};
        `
      : css`
          /* Add styles for the case when status is false or not provided */
          color: #000000;
          background-color: ${(props) => props.theme.palette.common.white};
          // border: 2px dotted gray;
        `}
`;

export const Month = styled(Box)``;

export const Day = styled(Box)``;

export const Name = styled(Box)``;
